import * as React from "react";
import { forwardRef } from "react";
const SvgInfoCircle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 32, height: 32, rx: 16, fill: "#E8EFFA" }), /* @__PURE__ */ React.createElement("path", { d: "M14.875 14.875H16.375V20.5M16.375 20.5H18.25M16.375 20.5H14.5M15.625 12.25V11.5H16.375V12.25H15.625Z", stroke: "#1045A1", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgInfoCircle);
export { ForwardRef as ReactComponent };
